import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';
import {elementIdSchema} from '../../schemas';

const toolName = 'set-form-name' as const;

const argumentZod = z.object({
  elementId: elementIdSchema.describe(
    'The ID of the Form element to set the name on. Must be a FormForm or FormWrapper element.'
  ),
  name: z
    .string()
    .describe(
      'The name to assign to the form. Used for form identification and processing.'
    ),
});

export const setFormNameTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Set form name',
  llmTool: {
    name: toolName,
    description: dedent`
      Set the name of a form element. Updates the form's name property which is
      used for identification and form processing. Only works with Form elements
      (FormForm or FormWrapper types). Returns null when the name is successfully
      set. Form names are important for backend processing and analytics.`,
    inputSchema: argumentZod,
  },
  type: 'designer',
  confirmBeforeExecuting: true, // Modifies form configuration, requires confirmation
  timeout: 30000, // 30 seconds for setting form name
});
